import React from 'react';

import { H2 } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn } from 'styles/layouts';

import { MediaElement } from '../shared/mediaElement';
import TextBlock from '../shared/TextBlock/TextBlock';

import { TwoRowsContainer } from './styles';
import { BulkTextProps } from './types';

export const TwoColumnsVariation: React.FC<
  Omit<BulkTextProps, 'variation'>
> = ({ title, textBlock1, media, textBlock2 }) => {
  return (
    <TwoRowsContainer>
      <FlexColumn gap="16px">
        <H2 bold>{title}</H2>
        <>
          {textBlock1 && <TextBlock text={textBlock1} />}
          {textBlock2 && <TextBlock text={textBlock2} />}
        </>
      </FlexColumn>
      <MediaElement {...media} aspectRatio="4/5" legacyStyles={false} />
    </TwoRowsContainer>
  );
};
